import {location,ulogin} from "../owtsdk/OwtSdkAjax";
import {locationInfo,uloginInfo} from "../owtsdk/errInfo";
import {localStorages} from "../storage/localStorage";
import FILTER from '../../filters/index'
import GLOBAL from '../global_variable'

var CCLogin = async function (data) {
    let LocationInfo = await locationInfo(await location({name:data.name}).catch(res=>{return res}));
    if(LocationInfo.code == 1){return LocationInfo}else{
        localStorages.set('serverAddress',LocationInfo.data);
        GLOBAL.requestUrl = FILTER.getServerUrl(1);
        let UloginInfo = await uloginInfo(await ulogin(data).catch(res=>{return res}));
        if(UloginInfo.code == 1){
            return UloginInfo
        }else {
           // let loginData = Object.assign(UloginInfo.data,data);
           // localStorages.set(`loginInfo_${UloginInfo.data.uid}`,loginData);
            return {
                code:0,
                data:UloginInfo.data
            }
        }
    }
};
export default CCLogin